import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiciosService } from 'app/services/servicios.service';
import { Service } from 'app/entities/servicios-backend';
import { TipoServicio } from 'app/entities/tipo_servicio';
import { faCheckDouble, faEnvelope, faSave, faCheck  } from '@fortawesome/free-solid-svg-icons';
import { PrioridadesService } from 'app/services/prioridades.service';
import * as moment from 'moment'; 
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-post-servicio',
  templateUrl: './post-servicio.component.html',
  styleUrls: ['./post-servicio.component.scss']
})
export class PostServicioComponent implements OnInit {

    public tiempoMax: number;
    public tableOpt: Array<Service>;
    public tipoServicios: Array<TipoServicio>;
    rangosPrioridad;
    public spinner;

    public rojo;
    public amarillo;
    public verde;
    public verde2;
    public verde3;
    public verde4;
    public valuetsc1=25;
    public valuetsc2=50;
    public valuetsc3=75;
    public valuetsc4=100;

    public faCheckDouble;
    public faEnvelope;
    public faSave;
    public faCheck;

    private fechaFinal: string;
    private fechaInicial: string;
    public fecha_final: any = moment();
    public fecha_inicial:any = moment("2014-03-22");

    coinwallet: string[] = ['Notas Contratos','Notas Cartera'];
    selectedwallet = this.coinwallet[0];
  
    //Data Table
    public dataTable_options;
    @ViewChild(DataTableDirective, {static:true})
    tabla: DataTableDirective;
    public dtTrigger: Subject<void>


  constructor(private serviciosService: ServiciosService,private prioridades: PrioridadesService) { }

  ngOnInit() {
    this.getServicios();
    this.serviciosService.serviciostiemposconsulta().subscribe((data)=>{
        this.rojo = data[0].tiempo;
        this.amarillo = data[1].tiempo;
        this.verde = data[2].tiempo;
        this.verde2 = data[3].tiempo;
        this.verde3 = data[4].tiempo;
        this.verde4 = data[5].tiempo;
      })

      this.faCheckDouble = faCheckDouble;
      this.faEnvelope = faEnvelope;
      this.faSave = faSave;
      this.faCheck = faCheck;

      this.dataTable_options = {
        scrollX: true,
        scrollY: '383px',
        responsive:true,
        scrollCollapse: true,
        Processing:true,
        language: {
          sProcessing: "Procesando...",
          sLengthMenu: "Mostrar _MENU_ registros",
          sZeroRecords: "No se encontraron resultados",
          sEmptyTable: "Ningún dato disponible en esta tabla",
          sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
          sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
          sInfoPostFix: "",
          sSearch: "Buscar:",
          sUrl: "",
          sInfoThousands: ",",
          sLoadingRecords: "Cargando...",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior"
          }
        },
        dom: 'Blfrtip',
        buttons: [
              {
                extend: 'excel',
                text: 'Excel'
              }
          ]
      };
  }

  async getServicios() {
    this.spinner = true;
    this.serviciosService.getPrioridad().subscribe(
      (data: Array<Service>) => {
        this.tableOpt = data;
        console.log(data);
        this.serviciosService.getPrioridadDespacho(this.tableOpt).subscribe(data=>{
          console.log(data);
          for (let i = 0; i < this.tableOpt.length; i++) {
            const tableRow = this.tableOpt[i];
            if (tableRow.reqcda === 'V'){
                if (tableRow.ApoyoVip === 1){
                    tableRow.prioridad = 'VIP';
                } else if (tableRow.Ape === 1) {
                    tableRow.prioridad = 'APE';
                }else if(tableRow.grutpc === 5){
                    tableRow.prioridad = 'AREA';
                }else if (tableRow.bencba === 15){
                    tableRow.prioridad = 'COR';
                }else{
                    tableRow.prioridad = data[i].prioridad;
                }
            }
          }
        });
        this.spinner = false;
      }
    );
  }

  getTSC(index: number = 0, maxTime: number): number{
    const date = new Date();
    let horaActual: Date = new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`);
    if (this.tableOpt[index].reqhll) {
      horaActual = new Date(`${this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "")} ${this.tableOpt[index].reqhll}`);
    }
    const horaServicio = new Date(`${this.tableOpt[index].reqdia.replace(/T+[^\n]+/g, "")} ${this.tableOpt[index].reqhor}`);
    const diferenciaDeTiempo = (horaActual.getTime() - horaServicio.getTime());
    const diferenciaDeTiempoEnMinutos = Math.floor(diferenciaDeTiempo / (60000));
    const porcentajeDeDiferenciaConRespectoAlMaximo = diferenciaDeTiempoEnMinutos * 100 / maxTime;
    return Math.round(porcentajeDeDiferenciaConRespectoAlMaximo);
  }

}
